import { inject } from '@angular/core';
import { CanMatchFn } from '@angular/router';
import { Store } from '@ngrx/store';

import { selectNotificationInbox } from '@app/generated/feature-flags.selectors';

/**
 * The `/notifications` routes exist only while `notificationInbox` is on. With the flag off the URL falls through to
 * not-found, exactly as before the inbox existed; saved notifications are untouched and come back when it is on.
 */
export const notificationInboxCanMatch: CanMatchFn = () =>
  inject(Store).selectSignal(selectNotificationInbox)();
